<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path data-name="패스 3909" d="M0 0h24v24H0z" style="fill: none" />
    <g data-name="그룹 8683" transform="translate(-629 -582)">
      <rect
        data-name="사각형 6133"
        width="18"
        height="22"
        rx="2"
        transform="translate(632 583)"
        style="fill: #ffc304"
      />
    </g>
    <path
      data-name="빼기 14"
      d="M18893.178 15298h-.174v-8h6v8h-.174l-2.832-2.827-2.826 2.827z"
      transform="translate(-18881 -15289)"
      style="fill: #087ef7"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style></style>
